import { render } from "./WarrantyClaimView.vue?vue&type=template&id=0f7efe45"
import script from "./WarrantyClaimView.vue?vue&type=script&lang=js"
export * from "./WarrantyClaimView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__